








import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

interface Data {}

interface Methods {}

interface Computed {}
interface Props {
  text: string;
  hovering: boolean;
  error: boolean;
  labelMargin: string;
}

export default Vue.extend({
  name: 'UiLabel',
  props: {
    text: {
      type: String,
      default: () => '',
    },
    hovering: {
      type: Boolean,
      default: () => true,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    labelMargin: {
      type: String,
      default: () => '8px',
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
